import Admin from "./Admin"
import Technicians from "./Technicians";
// import User from "./User"
import Login from "./Login"
import React, { useEffect, useState, useRef } from "react";
// import { app } from "./FireBase"
// import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
// import { getDatabase, ref, child, get, onValue } from "firebase/database";
// import { auth, dbRefAdmins, dbRefTech } from "./FireBase";
import LineChart from "./LineChart.tsx"



function App() {
    console.error = () => { };
    // console.log = () => { };
    console.warn = () => { };

    const [isLoggedIn, setIsLoggedIn] = useState("false")
    const [userCred, setUserCred] = useState(null)
    const [tech, setTech] = useState()
    const [admins, setAdmins] = useState()
    const [users, setUsers] = useState()

    // ==================================================================================================================================
    // For real time auth check =========================================================================================================
    // ==================================================================================================================================

    useEffect(() => {
        if (sessionStorage.getItem("isLoggin") && sessionStorage.getItem("isLoggin") != "false") {
            setIsLoggedIn(sessionStorage.getItem("isLoggin"))
        }
    }, [])

    // ==================================================================================================================================
    // ==================================================================================================================================
    // ==================================================================================================================================

    return (
        <>
            {
                isLoggedIn == "admin" ?
                    <div>
                        <Admin userCred={userCred} isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />
                    </div> :
                    isLoggedIn == "owner" ?
                        <Admin userCred={userCred} isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} /> :
                    isLoggedIn == "tech" ?
                        <Technicians isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} /> :
                        isLoggedIn == "user" ?
                            <Admin userCred={userCred} isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} /> :
                            isLoggedIn == "false" ?
                                <Login users={users} setUsers={setUsers} admins={admins} setAdmins={setAdmins} tech={tech} setTech={setTech} setUserCred={setUserCred} isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} /> :
                                <Login users={users} setUsers={setUsers} admins={admins} setAdmins={setAdmins} tech={tech} setTech={setTech} setUserCred={setUserCred} isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />
            }
        </>
    )
}

export default App